import { Reset } from "@bluframe/blublocks"
import styled from "styled-components"

export const TechSpecsUl = styled(Reset.Ul)`
  column-gap: 10px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 14px;
  max-width: 900px;
`
